import { Input, Modal } from "@arco-design/web-react";
import { useEffect, useState } from "react";

import type { SysStaffItem, SysStaffPasswordResetMutation } from "../types";
import "./SysDeptUserPage.css";

type SysStaffPasswordResetModalProps = {
  state: { staff: SysStaffItem } | null;
  errorMessage: string;
  onClose: () => void;
  onClearError: () => void;
  onResetPassword: (userId: number, payload: SysStaffPasswordResetMutation) => Promise<void>;
};

/** 管理员重置用户密码弹窗。 */
export function SysStaffPasswordResetModal({
  state,
  errorMessage,
  onClose,
  onClearError,
  onResetPassword,
}: SysStaffPasswordResetModalProps) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [localErrorMessage, setLocalErrorMessage] = useState("");

  useEffect(() => {
    if (!state) {
      return;
    }
    setPassword("");
    setConfirmPassword("");
    setLocalErrorMessage("");
    onClearError();
  }, [state, onClearError]);

  /** 提交管理员重置密码。 */
  async function handleOk() {
    if (!state) {
      return;
    }
    if (password.length < 6) {
      setLocalErrorMessage("新密码至少 6 位。");
      return;
    }
    if (password !== confirmPassword) {
      setLocalErrorMessage("两次输入的密码不一致。");
      return;
    }
    setLocalErrorMessage("");
    await onResetPassword(state.staff.id, { password });
    onClose();
  }

  return (
    <Modal
      title="重置密码"
      visible={Boolean(state)}
      onCancel={onClose}
      onOk={handleOk}
      okText="确认重置"
      cancelText="取消"
      className="sys-dept-user-modal"
      unmountOnExit
    >
      {localErrorMessage || errorMessage ? (
        <div className="sys-dept-user-error">{localErrorMessage || errorMessage}</div>
      ) : null}
      <div className="sys-dept-user-modal-grid">
        <label className="sys-dept-user-field">
          <span>用户</span>
          <Input
            aria-label="用户"
            value={state ? state.staff.realname || state.staff.nickname || state.staff.username : ""}
            disabled
          />
        </label>
        <label className="sys-dept-user-field">
          <span>新密码</span>
          <Input.Password
            aria-label="新密码"
            value={password}
            onChange={setPassword}
            autoComplete="new-password"
          />
        </label>
        <label className="sys-dept-user-field">
          <span>确认密码</span>
          <Input.Password
            aria-label="确认密码"
            value={confirmPassword}
            onChange={setConfirmPassword}
            autoComplete="new-password"
          />
        </label>
      </div>
    </Modal>
  );
}
